<template>
	<div class="transaction-logo">
		<div class="transaction-logo__image">
			<slot name="image" />
		</div>
		<div class="transaction-logo__sub-image">
			<slot name="sub-image" />
		</div>
	</div>
</template>

<style scoped>
.transaction-logo {
	position: relative;

	width: 120px;
	height: 120px;

	margin: 0 auto;

	box-sizing: border-box;

	border: 1px solid rgb(43 119 175 / 24%);
	border-radius: 500px;
}

.transaction-logo__image > * {
	/* AMM/Klaytn/palaswap */

	position: absolute;
	width: 80px;
	height: 80px;
	left: calc(50% - 80px / 2);
	top: calc(50% - 80px / 2);

	border-radius: 50%;
}

.transaction-logo__sub-image > * {
	position: absolute;
	bottom: 0px;
	right: 0px;

	width: 40px;
	height: 40px;

	border-radius: 50%;

	box-sizing: border-box;

	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 8px;
	gap: 8px;

	position: absolute;

	background: #020714;
	border: 1px solid rgb(43 119 175 / 24%);
	border-radius: 500px;

	stroke: #ffffff;
}
</style>
